export enum PrerenderStatusCode {
	OK = 200,
	NOT_FOUND = 404,
	REDIRECT = 301
}
